import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { companyInfo } from '../data/mock';

const PrivacyPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <section className="pt-32 pb-20">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <h1 className="heading-1 mb-8">Privacy Policy</h1>
            
            <div className="prose prose-gray max-w-none space-y-8">
              <p className="body-large">
                SUPA ENERGY HUB ("us", "we", or "our") operates the www.supaenergyhub.com.au website (hereinafter referred to as the "Service").
              </p>
              
              <p className="text-gray-600 leading-relaxed">
                This page informs you of our policies regarding the collection, use, and disclosure of personal data when you use our Service and the choices you have associated with that data.
              </p>

              <p className="text-gray-600 leading-relaxed">
                We use your data to provide and improve the Service. By using the Service, you agree to the collection and use of information in accordance with this policy.
              </p>

              {/* Information Collection */}
              <section>
                <h2 className="heading-3 mb-4">Information Collection and Use</h2>
                <p className="text-gray-600 leading-relaxed">
                  We collect several different types of information for various purposes to provide and improve our Service to you.
                </p>
              </section>

              {/* Types of Data */}
              <section>
                <h2 className="heading-3 mb-4">Types of Data Collected</h2>
                
                <h3 className="font-semibold text-[#3D5A47] mt-6 mb-3">Personal Data</h3>
                <p className="text-gray-600 leading-relaxed mb-4">
                  While using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you ("Personal Data"). Personally identifiable information may include, but is not limited to:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-gray-600">
                  <li>Email address</li>
                  <li>First name and last name</li>
                  <li>Phone number</li>
                  <li>Address, State, Province, ZIP/Postal code, City</li>
                  <li>Cookies and Usage Data</li>
                </ul>

                <h3 className="font-semibold text-[#3D5A47] mt-6 mb-3">Usage Data</h3>
                <p className="text-gray-600 leading-relaxed">
                  We may also collect information on how the Service is accessed and used ("Usage Data"). This Usage Data may include information such as your computer's Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages, unique device identifiers and other diagnostic data.
                </p>
              </section>

              {/* Tracking & Cookies */}
              <section>
                <h2 className="heading-3 mb-4">Tracking & Cookies Data</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  We use cookies and similar tracking technologies to track the activity on our Service and hold certain information.
                </p>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Cookies are files with a small amount of data which may include an anonymous unique identifier. Cookies are sent to your browser from a website and stored on your device. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Service.
                </p>
                <h3 className="font-semibold text-[#3D5A47] mt-4 mb-3">Examples of Cookies we use:</h3>
                <ul className="list-disc pl-6 space-y-2 text-gray-600">
                  <li><strong>Session Cookies:</strong> We use Session Cookies to operate our Service.</li>
                  <li><strong>Preference Cookies:</strong> We use Preference Cookies to remember your preferences and various settings.</li>
                  <li><strong>Security Cookies:</strong> We use Security Cookies for security purposes.</li>
                </ul>
              </section>

              {/* Use of Data */}
              <section>
                <h2 className="heading-3 mb-4">Use of Data</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  SUPA ENERGY HUB uses the collected data for various purposes:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-gray-600">
                  <li>To provide and maintain the Service</li>
                  <li>To notify you about changes to our Service</li>
                  <li>To allow you to participate in interactive features of our Service when you choose to do so</li>
                  <li>To provide customer care and support</li>
                  <li>To provide analysis or valuable information so that we can improve the Service</li>
                  <li>To monitor the usage of the Service</li>
                  <li>To detect, prevent and address technical issues</li>
                </ul>
              </section>

              {/* Transfer of Data */}
              <section>
                <h2 className="heading-3 mb-4">Transfer of Data</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Your information, including Personal Data, may be transferred to — and maintained on — computers located outside of your state, province, country or other governmental jurisdiction where the data protection laws may differ than those from your jurisdiction.
                </p>
                <p className="text-gray-600 leading-relaxed mb-4">
                  If you are located outside Australia and choose to provide information to us, please note that we transfer the data, including Personal Data, to Australia and process it there.
                </p>
                <p className="text-gray-600 leading-relaxed">
                  Your consent to this Privacy Policy followed by your submission of such information represents your agreement to that transfer. SUPA ENERGY HUB will take all steps reasonably necessary to ensure that your data is treated securely and in accordance with this Privacy Policy.
                </p>
              </section>

              {/* Disclosure of Data */}
              <section>
                <h2 className="heading-3 mb-4">Disclosure of Data</h2>
                <h3 className="font-semibold text-[#3D5A47] mt-4 mb-3">Legal Requirements</h3>
                <p className="text-gray-600 leading-relaxed mb-4">
                  SUPA ENERGY HUB may disclose your Personal Data in the good faith belief that such action is necessary to:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-gray-600">
                  <li>To comply with a legal obligation</li>
                  <li>To protect and defend the rights or property of SUPA ENERGY HUB</li>
                  <li>To prevent or investigate possible wrongdoing in connection with the Service</li>
                  <li>To protect the personal safety of users of the Service or the public</li>
                  <li>To protect against legal liability</li>
                </ul>
              </section>

              {/* Security */}
              <section>
                <h2 className="heading-3 mb-4">Security of Data</h2>
                <p className="text-gray-600 leading-relaxed">
                  The security of your data is important to us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute security.
                </p>
              </section>

              {/* Service Providers */}
              <section>
                <h2 className="heading-3 mb-4">Service Providers</h2>
                <p className="text-gray-600 leading-relaxed">
                  We may employ third-party companies and individuals to facilitate our Service ("Service Providers"), to provide the Service on our behalf, to perform Service-related services or to assist us in analyzing how our Service is used. These third parties have access to your Personal Data only to perform these tasks on our behalf and are obligated not to disclose or use it for any other purpose.
                </p>
              </section>

              {/* Analytics */}
              <section>
                <h2 className="heading-3 mb-4">Analytics</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  We may use third-party Service Providers to monitor and analyze the use of our Service.
                </p>
                <h3 className="font-semibold text-[#3D5A47] mt-4 mb-3">Google Analytics</h3>
                <p className="text-gray-600 leading-relaxed">
                  Google Analytics is a web analytics service offered by Google that tracks and reports website traffic. Google uses the data collected to track and monitor the use of our Service. You can opt out of having made your activity on the Service available to Google Analytics by installing the Google Analytics opt-out browser add-on. For more information on the privacy practices of Google, please visit the Google Privacy & Terms web page.
                </p>
              </section>

              {/* Links */}
              <section>
                <h2 className="heading-3 mb-4">Links to Other Sites</h2>
                <p className="text-gray-600 leading-relaxed">
                  Our Service may contain links to other sites that are not operated by us. If you click on a third-party link, you will be directed to that third-party's site. We strongly advise you to review the Privacy Policy of every site you visit. We have no control over and assume no responsibility for the content, privacy policies or practices of any third-party sites or services.
                </p>
              </section>

              {/* Children's Privacy */}
              <section>
                <h2 className="heading-3 mb-4">Children's Privacy</h2>
                <p className="text-gray-600 leading-relaxed">
                  Our Service does not address anyone under the age of 18 ("Children"). We do not knowingly collect personally identifiable information from anyone under the age of 18. If you are a parent or guardian and you are aware that your Children have provided us with Personal Data, please contact us. If we become aware that we have collected Personal Data from children without verification of parental consent, we take steps to remove that information from our servers.
                </p>
              </section>

              {/* Changes */}
              <section>
                <h2 className="heading-3 mb-4">Changes to This Privacy Policy</h2>
                <p className="text-gray-600 leading-relaxed">
                  We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page. We will let you know via email and/or a prominent notice on our Service, prior to the change becoming effective. You are advised to review this Privacy Policy periodically for any changes.
                </p>
              </section>

              {/* Contact */}
              <section className="pt-8 border-t border-black/10">
                <h2 className="heading-3 mb-4">Contact Us</h2>
                <p className="text-gray-600">
                  If you have any questions about this Privacy Policy, please contact us:
                </p>
                <p className="text-gray-600 mt-3">
                  Email: {companyInfo.email}<br />
                  Phone: {companyInfo.phone}
                </p>
              </section>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPage;
